<script>
  import { _, setLocale } from "../localization";
  import { fade } from "svelte/transition";
  import DropdownField from "../components/DropdownField.svelte";
  import ConsumerTermsEs from "../components/TermsContent/consumer/es/Terms.svelte";
  import ConsumerPrivacyEs from "../components/TermsContent/consumer/es/PrivacyPolicy.svelte";
  import BusinessTermsEs from "../components/TermsContent/business/es/Terms.svelte";
  import BusinessPrivacyEs from "../components/TermsContent/business/es/PrivacyPolicy.svelte";
  import ConsumerTermsEn from "../components/TermsContent/consumer/en/Terms.svelte";
  import ConsumerPrivacyEn from "../components/TermsContent/consumer/en/PrivacyPolicy.svelte";
  import BusinessTermsEn from "../components/TermsContent/business/en/Terms.svelte";
  import BusinessPrivacyEn from "../components/TermsContent/business/en/PrivacyPolicy.svelte";

  import { onMount } from "svelte";

  let ContentComponent;
  let languageValue = "es";
  let languageOptions = [
    {
      id: "es",
      title: "Spanish"
    },
    {
      id: "en",
      title: "English"
    },
  ];


  let selectedTab = "consumer.terms"
  const tabs = [
    {
        title: "Consumer",
        id: "consumer",
        tabs: [
            {
                title: "Terms of Service",
                id: "terms"
            },
            {
                title: "Privacy Policy",
                id: "privacy"
            }
        ]
    },
    {
        title: "Business",
        id: "business",
        tabs: [
            {
                title: "Terms of Service",
                id: "terms"
            },
            {
                title: "Privacy Policy",
                id: "privacy"
            }
        ]
    },
  ];

  $: {
    languageValue;
    languageChanged();
  }

  function languageChanged(){
    if (languageValue == "es") {
        setLocale("es-mx");
    }
    else{
        setLocale("en-us");
    }

    tabSelected(...selectedTab.split("."), true);
  }
  
  function tabSelected(sectionId, tabId, dontToggle){
    //Set tab
    selectedTab = sectionId+"."+tabId;

    //Load component
    switch ([languageValue, selectedTab].join(".")) {
        case "es.consumer.terms":
            ContentComponent = ConsumerTermsEs;
            break;
        case "es.consumer.privacy":
            ContentComponent = ConsumerPrivacyEs;
            break;
        case "es.business.terms":
            ContentComponent = BusinessTermsEs;
            break;
        case "es.business.privacy":
            ContentComponent = BusinessPrivacyEs;
            break;
        case "en.consumer.terms":
            ContentComponent = ConsumerTermsEn;
            break;
        case "en.consumer.privacy":
            ContentComponent = ConsumerPrivacyEn;
            break;
        case "en.business.terms":
            ContentComponent = BusinessTermsEn;
            break;
        case "en.business.privacy":
            ContentComponent = BusinessPrivacyEn;
            break;

        default:
            break;
    }

    if (screenWidth <= 700 && menuOpen && !dontToggle) {
        toggleMenu();
    }
  }

  onMount(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const initialTab = urlParams.get('t');

    const selected = (initialTab == "privacy" ? "business.privacy" : (initialTab == "terms" ? "business.terms" : selectedTab)).split(".");
    
    tabSelected(...selected);
    
  });

  let screenWidth;

  let menuOpen = false;
  function toggleMenu(){
    menuOpen = !menuOpen;
  }

</script>
<style>
    *{
        font-size: 12px;
    }
    main{
        display: flex;
        flex-direction: row;
    }
    .sidebar{
        width: 300px;
        min-height: 100svh;
        border-right: 1px solid var(--light-gray);
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        gap: 20px;
        background: var(--white);
        z-index: 1;
    }
    .content{
        flex: 1;
        height: 100svh;
        overflow: scroll;
    }
    .sidebar_section{
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 10px;
    }
    .terms_tab{
        padding: 10px;
        border-radius: 6px;
        border: 1px solid var(--light-gray);
        background-color: var(--white);
        cursor: pointer;
    }
    .terms_tab:not(.selected):hover{
        background-color: var(--light-gray);
    }
    .logo{
        height: 2.5rem;
        min-height: 25px;
        width: auto;
        margin-bottom: 20px;
        margin-top: 10px;
    }
    .header_logo{
        height: 2.5rem;
        min-height: 25px;
        width: auto;
    }
    .logo_link{
        text-align: center;
    }
    .terms_tab{
        display: flex;
        flex-direction: row;
        height: 40px;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .terms_tab i{
        color: var(--gray);
    }
    .terms_tab:not(.selected):hover i{
        color: var(--black);
    }
    h3{
        font-size: 16px;
        font-weight: 500;
        padding: 0 10px;
    }
    .separator{
        width: 100%;
        height: 1px;
        background-color: var(--light-gray);
    }
    .terms_tab.selected{
        border-color: var(--blue);
        color: var(--blue);
        background-color: var(--light-blue);
    }
    .terms_tab.selected i{
        color: var(--blue);
    }
    .overlay{
        background-color: var(--black);
        opacity: 0.8;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
    }
    .header{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 60px;
        width: 100vw;
        position: relative;
        border-bottom: 1px solid var(--light-gray);
        position: fixed;
        background-color: var(--white);
    }
    .menu_toggle{
        position: absolute;
        left: 20px;
        cursor: pointer;
        height: 16px;
    }
    .menu_toggle i{
        font-size: 16px;
    }
    @media (max-width: 700px){
        .sidebar{
            left: -300px;
            position: fixed;
            transition: left 250ms ease-in-out;
        }
        .sidebar.open{
            left: 0;
        }
        .terms_container{
            margin-top: 60px;  
        }
    }
</style>
<main bind:clientWidth={screenWidth}>
    <div class="sidebar" class:open={menuOpen}>
        <div class="sidebar_section">
            <a class="logo_link" href="/">
                <img class="logo" src="assets/img/logo.png" alt="PoloPay Logo" />
            </a>
        </div>

        <div class="sidebar_section">
            <h3>{$_("Language")}</h3>
            <DropdownField idBasedValue={true} bind:value={languageValue} options={languageOptions} />
        </div>
        <div class="separator"></div>
        {#each tabs as tabs_section}
            <div class="sidebar_section">
                <h3>{$_(tabs_section.title)}</h3>
                {#each tabs_section.tabs as tab}
                    <div class="terms_tab" class:selected={selectedTab == tabs_section.id+"."+tab.id} on:click={() => tabSelected(tabs_section.id, tab.id)}>
                        <span>{$_(tab.title)}</span>
                        <i class="fa-regular fa-chevron-right"></i>
                    </div>
                {/each}
            </div>
        {/each}
    </div>
    <div class="content">
        {#if screenWidth <= 700}
            <div class="header">
                <div class="menu_toggle" on:click={toggleMenu}>
                    <i class="fa-solid fa-bars"></i>
                </div>
                <img class="header_logo" src="assets/img/logo.png" alt="PoloPay Logo" />
            </div>
        {/if}
        {#if ContentComponent}
            <div class="terms_container">
                <svelte:component this={ContentComponent}/>
            </div>    
        {/if}
        {#if screenWidth <= 700 && menuOpen}
            <div class="overlay" in:fade={{ duration: 250 }} out:fade={{ duration: 250 }} on:click={toggleMenu}></div>
        {/if}
    </div>
</main>